/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowUiShareAExportIcon16Light } from './ArrowUiShareAExportIcon16Light';
import { ArrowUiShareAExportIcon16Regular } from './ArrowUiShareAExportIcon16Regular';
import { ArrowUiShareAExportIcon16Solid } from './ArrowUiShareAExportIcon16Solid';
import { ArrowUiShareAExportIcon20Light } from './ArrowUiShareAExportIcon20Light';
import { ArrowUiShareAExportIcon20Regular } from './ArrowUiShareAExportIcon20Regular';
import { ArrowUiShareAExportIcon20Solid } from './ArrowUiShareAExportIcon20Solid';
import { ArrowUiShareAExportIcon24Regular } from './ArrowUiShareAExportIcon24Regular';
import { ArrowUiShareAExportIcon24Solid } from './ArrowUiShareAExportIcon24Solid';
import { ArrowUiShareAExportIcon32Regular } from './ArrowUiShareAExportIcon32Regular';
import { ArrowUiShareAExportIcon64Regular } from './ArrowUiShareAExportIcon64Regular';
var sizes = {
    16: {
        light: ArrowUiShareAExportIcon16Light,
        regular: ArrowUiShareAExportIcon16Regular,
        solid: ArrowUiShareAExportIcon16Solid,
    },
    20: {
        light: ArrowUiShareAExportIcon20Light,
        regular: ArrowUiShareAExportIcon20Regular,
        solid: ArrowUiShareAExportIcon20Solid,
    },
    24: {
        regular: ArrowUiShareAExportIcon24Regular,
        solid: ArrowUiShareAExportIcon24Solid,
    },
    32: {
        regular: ArrowUiShareAExportIcon32Regular,
    },
    64: {
        regular: ArrowUiShareAExportIcon64Regular,
    },
};
export var ArrowUiShareAExportIcon = forwardRef('ArrowUiShareAExportIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
